<div class="site-info clearfix">
   <!-- Menu filters -->
   <ul class="site-info_filters hidden-xs" *ngIf="getLobbyGameGroups">
    <ng-container *ngFor="let lobbyGroup of getLobbyGameGroups">
      <li><a routerLink="{{'/'+langCode+'/casino/home/'+lobbyGroup.multilingualUrlGameGroup[langCode]}}">{{lobbyGroup.name}}</a></li>
    </ng-container>
    <li><a routerLink="{{'/'+langCode+'/promotions'}}">{{'footerComp.promotions' | translate}}</a></li>
  </ul>
  <div class="main_wrapper mob-site--promotion-bg">
    <!-- Site promotions -->
    <div class="site-info_promotion">
      <div class="site-info_promotion--header">
        <h4 class="site-info_promotion--title">{{'siteInfoPromotions.title' | translate}}</h4>
        <!-- <img class="site-info_promotion--logo" src="/assets/img/{{websiteName}}-logo.{{websiteLogoExtension}}" alt="{{websiteName}}.com logo"
          title="{{websiteName}}.com" /> -->
      </div>

      <div class="site-info_promotion--body">
        <div class="show-below-992">
          <!-- New Swiper starts here -->
          <div class="seo-swiper swiper swiper-container clearfix">
            <div class="swiper-wrapper">
              <div class="swiper_card swiper-slide">
                <div class="site-info_promotion--card" [ngStyle]="{'background-image': 'url(' + apiUrl + '/' + mediaPath +'/promotion_box_1.png' + ')'}">
                  <h3 class="site-info_promotion--card-title">{{'siteInfoPromotions.card1Title' | translate}}</h3>
                  <p class="site-info_promotion--card-desc">{{'siteInfoPromotions.card1Desc' | translate}}</p>
                </div>
              </div>
              <div class="swiper_card swiper-slide">
                <div class="site-info_promotion--card" [ngStyle]="{'background-image': 'url(' + apiUrl + '/' + mediaPath +'/promotion_box_2.png' + ')'}">
                  <h3 class="site-info_promotion--card-title">{{'siteInfoPromotions.card2Title' | translate}}</h3>
                  <p class="site-info_promotion--card-desc">{{'siteInfoPromotions.card2Desc' | translate}}</p>
                </div>
              </div>
              <div class="swiper_card swiper-slide">
                <div class="site-info_promotion--card" [ngStyle]="{'background-image': 'url(' + apiUrl + '/' + mediaPath +'/promotion_box_3.png' + ')'}">
                  <h3 class="site-info_promotion--card-title">{{'siteInfoPromotions.card3Title' | translate}}</h3>
                  <p class="site-info_promotion--card-desc">{{'siteInfoPromotions.card3Desc' | translate}}</p>
                </div>
              </div>
            </div>
          </div>
          <!--ends here-->

          <!--Old Swiper code starts-->
          <!-- <swiper class="mySwiper swiper-control clearfix" [config]="swiperCardsConfig">
            <ng-template swiperSlide>
              <div class="swiper_card">
                <div class="site-info_promotion--card" [ngStyle]="{'background-image': 'url(' + apiUrl + '/' + mediaPath +'/promotion_box_1.png' + ')'}">
                  <h3 class="site-info_promotion--card-title">{{'siteInfoPromotions.card1Title' | translate}}</h3>
                  <p class="site-info_promotion--card-desc">{{'siteInfoPromotions.card1Desc' | translate}}</p>
                </div>
              </div>
            </ng-template>
            <ng-template swiperSlide>
              <div class="swiper_card">
                <div class="site-info_promotion--card" [ngStyle]="{'background-image': 'url(' + apiUrl + '/' + mediaPath +'/promotion_box_2.png' + ')'}">
                  <h3 class="site-info_promotion--card-title">{{'siteInfoPromotions.card2Title' | translate}}</h3>
                  <p class="site-info_promotion--card-desc">{{'siteInfoPromotions.card2Desc' | translate}}</p>
                </div>
              </div>
            </ng-template>
            <ng-template swiperSlide>
              <div class="swiper_card">
                <div class="site-info_promotion--card" [ngStyle]="{'background-image': 'url(' + apiUrl + '/' + mediaPath +'/promotion_box_3.png' + ')'}">
                  <h3 class="site-info_promotion--card-title">{{'siteInfoPromotions.card3Title' | translate}}</h3>
                  <p class="site-info_promotion--card-desc">{{'siteInfoPromotions.card3Desc' | translate}}</p>
                </div>
              </div>
            </ng-template>
          </swiper> -->
          <!--Old Swiper code ends here-->
            
        </div>
        <div class="hide-below-992 d-flex">
          <div class="site-info_promotion--card" [ngStyle]="{'background-image': 'url(' + apiUrl + '/' + mediaPath +'/promotion_box_1.png' + ')'}">
            <h3 class="site-info_promotion--card-title">{{'siteInfoPromotions.card1Title' | translate}}</h3>
            <p class="site-info_promotion--card-desc">{{'siteInfoPromotions.card1Desc' | translate}}</p>
          </div>
  
          <div class="site-info_promotion--card" [ngStyle]="{'background-image': 'url(' + apiUrl + '/' + mediaPath +'/promotion_box_2.png' + ')'}">
            <h3 class="site-info_promotion--card-title">{{'siteInfoPromotions.card2Title' | translate}}</h3>
            <p class="site-info_promotion--card-desc">{{'siteInfoPromotions.card2Desc' | translate}}</p>
          </div>
  
          <div class="site-info_promotion--card" [ngStyle]="{'background-image': 'url(' + apiUrl + '/' + mediaPath +'/promotion_box_3.png' + ')'}">
            <h3 class="site-info_promotion--card-title">{{'siteInfoPromotions.card3Title' | translate}}</h3>
            <p class="site-info_promotion--card-desc">{{'siteInfoPromotions.card3Desc' | translate}}</p>
          </div>
        </div>
      </div>
          <!-- Register block -->
    <div class="site-info_register site-info__footer">
      <div class="site-info_register--left">
        <p class="site-info_register--subtitle">{{'siteInfoRegsiter.subtitle' | translate}}</p>
        <h3 class="site-info_register--title">{{'siteInfoRegsiter.title' | translate}}</h3>
      </div>
      <div class="site-info_register--right">
        <button type="button" class="site-btn site-btn__primary" (click)="register()" *ngIf="isCountryAllowed === 2">
          <span>{{'siteInfoRegsiter.createanaccount' | translate}}</span>
        </button>
        <button type="button" class="site-btn site-btn__primary" (click)="moveToTrustlyPay()" *ngIf="isCountryAllowed === 1">
          <span class="depSpan">{{'siteInfoRegsiter.buttontext1' | translate}}</span>
          <span class="noRegSpan">{{'siteInfoRegsiter.buttontext2' | translate}}</span>
        </button>
      </div>
    </div>
    </div>

    
  </div>
<!-- They asked to remove from code base but developer point of you, it will required in the future if they want so I'm commented -->
  <!-- testimonial -->
  <!-- <div class="site-info_testimonial">
    <swiper class="mySwiper swiper-control clearfix" [config]="swiperTestimonialConfig">
      <div class="testimonial_card" *ngFor="let testimonial of [].constructor(7); let i = index;">
        <div class="testimonial_card--main-wrap">
          <h5 class="testimonial_card--main-title">{{'testimonials.testimonial'+ (i + 1) +'title' | translate}}</h5>
          <p class="testimonial_card--main-desc">{{'testimonials.testimonial'+ (i + 1) +'desc' | translate}}</p>
        </div>
        <div class="testimonial_card--details">
          <div class="testimonial_card--details-left">
            <img [attr.src]="'/assets/country_flags/'+('testimonials.testimonial'+ (i + 1) +'Flag' | translate)+'.svg'" alt="" />
            <div class="testimonial_card--userinfo">
              <span class="testimonial_card--userinfo-title">{{'testimonials.testimonial'+ (i + 1) +'username' | translate}}</span>
              <span class="testimonial_card--userinfo-subtitle">{{'testimonials.testimonial'+ (i + 1) +'cityname' | translate}}</span>
            </div>
          </div>
          <div class="testimonial_card--details-right">
            <ul class="testimonial_card--ratings">
              <li *ngFor="let rating of [].constructor(5); let j = index;" 
                [class.active]="('testimonials.testimonial'+ (i + 1) +'rating' | translate) > j">
              </li>
            </ul>
          </div>
        </div>
      </div>
    </swiper>
  </div> -->

  <!-- FAQ -->
  <app-static-pages [url]="'footerfaq'"></app-static-pages>
</div>